import Activities         from '../activities/activities.js';
import AddressFinder      from '../address/address-finder.js';
import AssessUser         from '../assess/assess-user.js';
import ChartManager       from '../analytics/analytics.js';
import DragDropManager    from '../admin/dragdrop.js';
import SortManager        from '../admin/sorter.js';
import ImportUsers        from '../import/import-users.js';
import ImportStudents     from '../import/import-students.js';
import ImportSubusers     from '../import/import-subusers.js';
import ImportTrainers     from '../import/import-trainers.js';
import Confirm            from '../alerts/confirm.js';
import Toaster            from '../alerts/toaster.js';
import Modal              from '../alerts/modal.js';
import Api                from '../api/api.js';
import ChangeLanguage     from '../language/change-language.js';
// import WorldMap           from '../map/world-map.js';
// import MapContinents      from '../map/map-continents.js';
// import MapProviders       from '../map/map-providers.js';
// import MapVisitor         from '../map/map-visitor.js';
import LornaLesson        from '../lesson/lorna-lesson.js';
import ListManager        from '../lists/list-manager.js';
import TagManager         from '../tags/tag-manager.js';
import ListManagerDeletor from '../lists/list-manager-deletor.js';
import ListManagerFilters from '../lists/list-manager-filters.js';

global.Activities         = Activities;
global.AssessUser         = AssessUser;
global.ChartManager       = ChartManager;
global.DragDropManager    = DragDropManager;
global.SortManager        = SortManager;
global.ImportUsers        = ImportUsers;
global.ImportStudents     = ImportStudents;
global.ImportSubusers     = ImportSubusers;
global.ImportTrainers     = ImportTrainers;
global.Confirm            = Confirm;
global.Toaster            = Toaster;
global.Modal              = Modal;
global.Api                = Api;
global.AddressFinder      = AddressFinder;
global.LornaLesson        = LornaLesson;
global.TagManager         = TagManager;
global.ListManager        = ListManager;
global.ListManagerDeletor = ListManagerDeletor;
global.ListManagerFilters = ListManagerFilters;
global.ChangeLanguage     = new ChangeLanguage;


//global.worldMap = new WorldMap(new MapContinents, new MapProviders, new MapVisitor); 